import React, { Component } from "react";

import Typography from "material-ui/Typography";
import Grid from "material-ui/Grid";

import RelatedNav from "./RelatedNav";

import getImage from "../imageService";

class Doctor extends Component {
  render() {
    const { service } = this.props;
    const image = getImage(service.id);

    const svgComponent = (
      <svg viewBox="0 0 887.6 934" className="doctorImg">
        <title>genericDoctor.svg_1</title>
        <g data-name="Layer 2">
          <g data-name="Layer 1">
            <path
              fill="none"
              stroke="#00bfa5"
              strokeMiterlimit={10}
              d="M580.74 670.5h-37.72v44.25h-44.24v37.71h44.24v44.25h37.72v-44.25h44.24v-37.71h-44.24V670.5z"
            />
            <path
              d="M643.76 388.46a280.73 280.73 0 0 1 75.37 140.41 66.21 66.21 0 1 1-22 1.87A269.84 269.84 0 0 0 583.72 363.6c-.56-.19-1.11-.39-1.66-.57l-142.49 252.5L304.5 363.36q-15.73 5.17-30.92 11.47c-55.17 44.51-86.21 114.07-88.77 199.65 56 4.89 100.46 74.14 100.46 159.13l-20.71 17.62a17.59 17.59 0 1 1-5.41-5.25L277 733.6c0-81.26-44.08-147.15-98.44-147.15s-98.48 65.9-98.48 147.15l16.29 11.33a17.46 17.46 0 1 1-6 4.53L71.74 733.6c0-80.22 39.62-146.4 91.17-157.73 2.6-73 24.12-138.94 72.12-187.48C101.64 455.41 15.37 587.29 0 742.7 88.28 879.11 254 934 443.8 934s355.53-54.89 443.8-191.3c-15.35-155.4-110.5-287.24-243.84-354.24zm-18.76 364h-44.26v44.25H543v-44.25h-44.22v-37.71H543V670.5h37.72v44.25H625z"
              fill="#00bfa5"
            />
            <path
              d="M713.57 638.14a43.41 43.41 0 0 0 9.3-85.81 43.76 43.76 0 0 0-52.75 42.36 43.46 43.46 0 0 0 43.45 43.45zM341.15 334.68c3.76 2.26 7.58 4.46 11.51 6.48a200.78 200.78 0 0 0 177.09 2.53q8.63-4.13 16.71-9c53.33-32.22 88.76-88.76 88.76-153.17C635.2 81.27 549.52 0 443.8 0S252.38 81.27 252.38 181.51c0 64.42 35.43 120.95 88.77 153.17z"
              fill="#00bfa5"
            />
          </g>
        </g>
      </svg>
    );

    return (
      <Grid item md={8} lg={9}>
        <Typography variant="display2" className="entityHeading">
          {service.title + " " + service.name}
        </Typography>
        <Typography style={{ fontSize: "16px", marginBottom: "16px" }}>
          {service.category}
        </Typography>
        <Grid container direction="row" justify="flex-start">
          <Grid item>
            <Typography variant="body2" gutterBottom>
              {image === null ? (
                svgComponent
              ) : (
                <img src={image} alt={service.name} className="doctorImg" />
              )}
            </Typography>
          </Grid>
          <Grid item xs={12} md={8} lg={6}>
            <Typography variant="body2" component="pre" gutterBottom style={{whiteSpace: "pre-line"}}>
              {service.cv}
            </Typography>
          </Grid>
        </Grid>
        {service.usluge ? <RelatedNav service={service} /> : ""}
      </Grid>
    );
  }
}

export default Doctor;



// WEBPACK FOOTER //
// ./src/components/Doctor.js